<app-modal>
    <form class="form">
        <div class="form_group">
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Название</div>
                <div class="col-17"><input name="name" [(ngModel)]="productForm.name" type="text" class="inp"
                        placeholder="Название"></div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Цена</div>
                <div class="col-17"><input type="email" name="price" [(ngModel)]="productForm.price" class="inp"
                        placeholder="Цена"></div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Товар включён</div>
                <div class="col-17">
                    <select [(ngModel)]="productForm.isEnabled" name="isEnabled" class="inp">
                        <option value="true">Да</option>
                        <option value="false">Нет</option>
                    </select>
                </div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Требует доставку</div>
                <div class="col-17">
                    <select [(ngModel)]="productForm.requireShipping" name="requireShipping" class="inp">
                        <option value="true">Да</option>
                        <option value="false">Нет</option>
                    </select>
                </div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Описание <div class="color_violet fz_xxs">(не обязательно)</div>
                </div>
                <div class="col-17">
                    <textarea class="inp description" name="description" placeholder="Введите описание"
                        [(ngModel)]="productForm.description"></textarea>
                </div>
            </label>
        </div>
        <div class="btns_container row fw_500 fz_s">
            <button (click)="closeModal()" class="btn btn_cancel">Отмена</button>
            <button (click)="createProduct()" [disabled]="isLoadingSend" class="btn dark_btn row"><span *ngIf="isLoadingSend" class="loader"></span> <span *ngIf="!isLoadingSend">Создать</span></button>
        </div>
    </form>
</app-modal>